// extracted by mini-css-extract-plugin
module.exports = {"SliderControl":"SliderControl_SliderControl__1W4A1","Icon":"SliderControl_Icon__2Q8I-"};